// Copyright (c) Docugami, Inc. All rights reserved.

import { IconRenderer } from 'components/work_path/IconRenderer';
import { dgIconNames } from 'hooks/dgIcons';
import styled from 'styled-components';
import { ErrorPageSubText, ErrorPageTitleText } from 'components/common/Fonts';
import { emptyColor } from 'components/shell/presentation/AppStyles';
import { DgButton } from 'components/common/DgCommonStyledComponents';
import { useDgAuth } from 'hooks/DgAuthentication';
import { DgUnauthenticatedShell } from 'components/shell/presentation/Header';
import { useEffect } from 'react';
import { Telemetry } from 'telemetry/TelemetryManager';
import { TelemetryPageView } from 'telemetry/TelemetryEvents';

const Root = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    min-height: 600px;
    align-self: center;
    justify-self: center;
    width: 100%;
    height: 100%;
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    align-items: center;
`;

const RedirectButton = styled(DgButton)`
    width: fit-content;
    margin-top: 10px;
`;

interface SessionExpiredPageProps {
    location: any;
}

interface SessionExpiredPageUXProps extends SessionExpiredPageProps {
    onTrySignIn: () => void;
}

export const SessionExpiredPageUX = (props: SessionExpiredPageUXProps) => {
    return (
        <DgUnauthenticatedShell>
            <Root>
                <IconRenderer
                    source={{
                        name: dgIconNames.DgRobotLarge,
                        height: 485,
                        width: 424,
                        defaultColor: emptyColor
                    }}
                    width={250}
                    height={300} />
                <TextContainer>
                    <ErrorPageTitleText>SESSION EXPIRED</ErrorPageTitleText>
                    <ErrorPageSubText>Click below to reload the page. You may be prompted to sign in.</ErrorPageSubText>
                    <RedirectButton key={'login_redirect'} onClick={props.onTrySignIn}>Try again</RedirectButton>
                </TextContainer>
            </Root>
        </DgUnauthenticatedShell>
    )
}

export const SessionExpiredPage = (props: SessionExpiredPageProps): JSX.Element => {

    useEffect(() => {
        Telemetry.trackPageView(TelemetryPageView.SessionExpired);
    }, []);

    const { loginWithRedirect } = useDgAuth();
    return <SessionExpiredPageUX onTrySignIn={loginWithRedirect} {...props} />
}
